import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[60vh] text-center px-4 py-20">
      <span className="absolute text-[8rem] md:text-[12rem] font-heading font-black text-background-100 select-none pointer-events-none">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-5">
          <i className="ri-film-line text-3xl"></i>
        </span>
        <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-2 text-sm font-body text-foreground-500">未找到该页面：{location.pathname}</p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
          <Link
            to="/"
            className="flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line text-base"></i>
            </span>
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-sm font-label text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            浏览影视分类
          </Link>
        </div>
      </div>
    </div>
  );
}